import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Switch } from 'ui/atoms'
import Tooltip from 'ui/components/Tooltip/Tooltip'

type SettingEditorModeSwitchProps = {
  opensInSplitView: boolean
  onChange: (opensInSplitView: boolean) => void
}

/** Chooses whether settings open in a popup or in the split view, and moves an open split view to a popup. */
export function SettingEditorModeSwitch({ opensInSplitView, onChange }: SettingEditorModeSwitchProps): ReactNode {
  const { t } = useTranslation()

  return (
    <Tooltip title={t('Open settings in')} arrow>
      <div role="group" aria-label={t('Open settings in')}>
        <Switch
          items={[
            { value: 'modal', label: t('Popup') },
            { value: 'splitView', label: t('Split view') },
          ]}
          value={opensInSplitView ? 'splitView' : 'modal'}
          onClick={(mode) => onChange(mode === 'splitView')}
        />
      </div>
    </Tooltip>
  )
}
